import React, { Component } from 'react';
import {CardNumberElement, CardExpiryElement, CardCVCElement, injectStripe} from 'react-stripe-elements';

import '../../assets/styles/credit-card.css';
const cardStyles = {
    base: {
        fontSize: '16px',
        color: '#424770',
        letterSpacing: '0.025em',
        fontFamily: 'Source Code Pro, monospace',
        '::placeholder': {
            color: '#aab7c4',
        }
    },
    invalid: {
        color: '#9e2146',
    }
};

class CreditCard extends Component {

    constructor(props) {
        super(props);
        this.state = {loadingToken: false};
    }

    async submit() {
        this.setState({loadingToken: true}, async () => {
            let {token} = await this.props.stripe.createToken({name: `${this.props.member.first_name} ${this.props.member.last_name}`});
            this.setState({loadingToken: false});
            this.props.callbackToUpdateComponent({credit_card: token});
        });
        return false;
    }

    render () {
        return (
            <div className='col-md-12'>
                <div id='card-form' className='row'>
                    <div className='col-lg-7 col-md-7 col-xs-12'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='form-group'>
                                    <label>Card Number</label>
                                    <CardNumberElement style={cardStyles} />
                                </div>
                            </div>

                            <div className='col-md-6 col-lg-6 col-xs-12'>
                                <div className='form-group'>
                                    <label>Card Expiry</label>
                                    <CardExpiryElement style={cardStyles} />
                                </div>
                            </div>

                            <div className='col-md-6 col-lg-6 col-xs-12'>
                                <div className='form-group'>
                                    <label>CVC</label>
                                    <CardCVCElement style={cardStyles} />
                                </div>
                            </div>

                            <div className='col-lg-12 col-md-12 col-xs-12'>
                                <div className='form-group'>
                                    <label>Zip Code</label>
                                    <input type='text' name='zip' className='full-width' placeholder='Zip code' />
                                </div>
                            </div>

                            <div className='col-md-12 col-lg-12 col-xs-12'>
                                <button className='mt-15' onClick={this.submit.bind(this)}>
                                    {this.state.loadingToken && <i className="fa fa-spinner fa-spin" />}
                                    {!this.state.loadingToken && 'Pay Now!'}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-5 col-md-5 col-xs-12 mb-15'>
                        <i className='pf pf-visa' />
                        <i className='pf pf-mastercard' />
                        <i className='pf pf-american-express' />
                        <i className='pf pf-discover' />
                        <i className='pf pf-diners' />
                        <i className='pf pf-jcb' />
                    </div>
                </div>
            </div>
        );
    }
}

export default injectStripe(CreditCard);
